import script from "./DatasetsView.vue?vue&type=script&setup=true&lang=js"
export * from "./DatasetsView.vue?vue&type=script&setup=true&lang=js"

import "./DatasetsView.vue?vue&type=style&index=0&id=dd385b86&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd385b86"]])

export default __exports__